<template>
  <div class="content">
    <NavBar />
    <v-main>
      <v-container fluid>
        <div class="content-main">
          <v-card class="profile" title="Perfil">
            <v-card-text>
              <ProfileModule />
            </v-card-text>
          </v-card>
          <v-card class="main pa-5" title="Configuración">
            <v-tabs v-model="tab" align-tabs="end" color="primary">
              <v-tab :value="1">Perfil</v-tab>
              <v-tab :value="2">Contraseña</v-tab>
              <v-tab :value="3">Notificaciones</v-tab>
            </v-tabs>
            <v-tabs-window v-model="tab">
              <v-tabs-window-item :key="1" :value="1">
                <SettingData />
              </v-tabs-window-item>
              <v-tabs-window-item :key="2" :value="2">
                <SettingPassword />
              </v-tabs-window-item>
              <v-tabs-window-item :key="3" :value="3">
                <SettingNotification />
              </v-tabs-window-item>
            </v-tabs-window>            
          </v-card>
          <v-card class="skills" title="Mis Competencias">
            <v-card-text>
              <SkillModuleVue />
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </v-main>
  </div>
</template>
<script setup>
  import { ref } from 'vue';
  import NavBar from '../components/navbar/NavBar'
  import ProfileModule from '../components/profile/ProfileModule'
  import SkillModuleVue from '@/components/profile/SkillModule.vue';
  import SettingData from '../components/setting/SettingData'
  import SettingPassword from '@/components/setting/SettingPassword.vue'
  import SettingNotification from '@/components/setting/SettingNotification.vue'

  const tab = ref(1)

</script>